import {
  TableCellLayout,
  TableColumnSizingOptions,
} from "@fluentui/react-components";
import { compareFieldValues, getTypedFieldType } from "./FieldService";
import { DisplayField } from "../components/DisplayField";
import { FieldTypes, NumFieldType } from "../models/FieldTypes";
import { Activity, FIELDS_SHOW_PATH } from "../models/Activity";
import { Tool } from "../models/Tool";
import { Image } from "../models/Image";
import { Field, FieldValue } from "../models/Field";
import { VsaTableColumnDefinition } from "../constants/DataGridColumns";
import {
  ContactPersonFieldUniqueName,
  ImprovementLeaderFieldUniqueName,
  PublishAsGeneratedPdfFieldUniqueName,
  SupportingRoleFieldUniqueName,
} from "../constants/Fields";
import { getPublishAsGeneratedPdfDisplayValue } from "../constants/PublishAsGeneratedPdf";
// The size settings for all columns that we use. This can contain columns that are not used in the list.
// This is located here so we can have definition for all field column sizes in one place and reuse it wherever we use
// a DataGrid component that use some or all of these columns.
export const FieldColumnSizes: TableColumnSizingOptions = {
  title: {
    minWidth: 250,
  },
  versionId: {
    minWidth: 280,
  },
  activityId: {
    minWidth: 280,
  },
  toolId: {
    minWidth: 280,
  },
  version: {
    minWidth: 50,
    defaultWidth: 50,
  },
  active: {
    minWidth: 50,
    defaultWidth: 50,
  },
  type: {
    minWidth: 25,
    defaultWidth: 25,
  },
  activities: {
    minWidth: 140,
    defaultWidth: 140,
  },
  name: {
    minWidth: 225,
    defaultWidth: 225,
  },
  adminDisplayName: {
    minWidth: 225,
  },
};

export const getColumnForField = (field: Field, hideBooleanField: boolean) => {
  if (field.type === NumFieldType.PeoplePicker && hideBooleanField) {
    return;
  }

  if (
    hideBooleanField &&
    (field.uniqueName === ImprovementLeaderFieldUniqueName ||
      field.uniqueName === SupportingRoleFieldUniqueName ||
      field.uniqueName === PublishAsGeneratedPdfFieldUniqueName)
  ) {
    return;
  }

  if (field.uniqueName === PublishAsGeneratedPdfFieldUniqueName) {
    const column: VsaTableColumnDefinition<Activity | Tool | Image> = {
      columnId: field.uniqueName,
      compare: "",
      renderHeaderCell: () => "Publiceringsformat",
      renderCell: (item) => (
        <TableCellLayout>
          <DisplayField
            type={FieldTypes.Text}
            label="Publiceringsformat"
            value={getPublishAsGeneratedPdfDisplayValue(
              item.fieldValues?.booleans[field.uniqueName]
            )}
          />
        </TableCellLayout>
      ),
    };

    return column;
  }

  const fieldType = getTypedFieldType(field.type);
  const isProcessField = field.uniqueName === "process";

  const column: VsaTableColumnDefinition<Activity | Tool | Image> = {
    columnId: field.uniqueName,
    compare: !field.multiValue
      ? (a, b) => compareFieldValues(a.fieldValues, b.fieldValues, field)
      : "",
    renderHeaderCell: () => {
      return field.displayName;
    },
    renderCell: (item) => {
      const showPath = FIELDS_SHOW_PATH.includes(field.uniqueName);
      let fieldValue: FieldValue;

      if (fieldType === FieldTypes.Tag) {
        fieldValue = item.fieldValues?.tags[field.uniqueName];
      } else if (
        fieldType === FieldTypes.BooleanCheckBox ||
        fieldType === FieldTypes.BooleanSwitch
      ) {
        fieldValue = item.fieldValues?.booleans[field.uniqueName];
      } else if (fieldType === FieldTypes.Url) {
        fieldValue = item.fieldValues?.urls[field.uniqueName];
      } else if (
        fieldType === FieldTypes.User ||
        field.uniqueName == ContactPersonFieldUniqueName
      ) {
        fieldValue = item.fieldValues?.users[field.uniqueName];
      } else {
        fieldValue = item.fieldValues?.users[field.uniqueName];
      }

      return (
        <TableCellLayout>
          <DisplayField
            type={fieldType}
            label={field.displayName}
            value={fieldValue}
            showPath={showPath}
            linkToClientApp={isProcessField}
          />
        </TableCellLayout>
      );
    },
  };

  return column;
};
